/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Folders(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M224,72H154.6665a7.99938,7.99938,0,0,1-4.7998-1.6L122.1333,49.6a7.99938,7.99938,0,0,0-4.7998-1.6H72a7.99993,7.99993,0,0,0-8,8V80H85.3335a7.99938,7.99938,0,0,1,4.7998,1.6l27.7334,20.8a7.99938,7.99938,0,0,0,4.7998,1.6H192a7.99993,7.99993,0,0,1,8,8v64h24.88867A7.1111,7.1111,0,0,0,232,168.88892V80A7.99993,7.99993,0,0,0,224,72Z"
        opacity={0.2}
      />
      <Path
        d="M200,112v88.88889A7.11111,7.11111,0,0,1,192.88889,208H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M64,80V56a8,8,0,0,1,8-8h45.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.88889A7.11111,7.11111,0,0,1,224.88889,176H200"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Folders;
